export const getHeaderContent = ({
  fromFieldArray,
  linkageDeletionId,
  linkageRowDeletionData,
}) => {
  let headerContent = {
    header: "",
    content: "",
  };
  switch (fromFieldArray) {
    case "eta_790a_addendum_a":
      headerContent = {
        header: "Remove Crop/Agricultural Activity",
        content: (
          <p>
            Please confirm you wish to delete this Crop/Activity{" "}
            <strong>
              <em>
                <span style={{ color: "red" }}>{linkageDeletionId}</span>
              </em>
            </strong>{" "}
            from <strong>Addendum A</strong>, as it will also be removed from{" "}
            <strong>
              (
              <span style={{ color: "#1076be" }}>
                {linkageRowDeletionData?.length}
              </span>
              )
            </strong>{" "}
            worksite linkages in <strong>Addendum B table C.2</strong> shown
            below:
          </p>
        ),
      };
      break;
    case "agBusinesses":
      headerContent = {
        header: "Remove Agricultural Business and Places of Employment",
        content: (
          <p>
            Please confirm you wish to delete this Agricultural Business from{" "}
            Table C.1, as it will also delete (
            <span style={{ color: "#1076be" }}>
              <strong>{linkageRowDeletionData?.length}</strong>
            </span>
            ) worksite(s) in Table C.2 as they are linked:
          </p>
        ),
      };
      break;
    default:
  }
  return headerContent;
};
